import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import DrawerOrDialog from './components/DrawerOrDialog';
import ListLimits from './components/ListLimits';
import TitleAndDescription from './components/TitleAndDescription';

import useAccountLimits from './hooks/useAccountLimits';

export default function TransactionLimitsModal({ handleClose }) {
  const {
    achDailyDebitLimit,
    achMonthlyDebitLimit,
    achDailyCreditLimit,
    achMonthlyCreditLimit,
    instantDepositMonthlyTransferLimit,
    instantDepositPerTransferLimit,
    instantDepositMinimumTransferLimit,

    checkDepositDailyLimit,
    checkDepositMonthlyLimit,

    checkPaymentDailyLimit,
    checkPaymentMonthlyLimit,

    dailyCardWithdrawalLimit,
    dailyCardPurchaseLimit,
    loading
  } = useAccountLimits();

  const moneyInLimits = [
    {
      title: 'Bank transfers (ACH)',
      description: `Limit ${achDailyDebitLimit} per day and ${achMonthlyDebitLimit} per month. Takes 4 to 5 business days.`,
      src: '/s2/material-icons/accountbalancerounded.svg'
    },
    {
      title: 'Instant deposit (external debit card)',
      description: `Limit ${instantDepositPerTransferLimit} and minimum ${instantDepositMinimumTransferLimit} per transaction. Limit ${instantDepositMonthlyTransferLimit} per month.`,
      src: '/s2/material-icons/creditcardrounded.svg'
    },
    {
      title: 'Check deposit',
      description: `Limit ${checkDepositDailyLimit} per day and ${checkDepositMonthlyLimit} per month. Takes 5 business days.`,
      src: '/s2/icon/camera-fill.svg'
    }
  ];
  const moneyOutLimits = [
    {
      title: 'Bank transfers (ACH)',
      description: `Limit ${achDailyCreditLimit} per day and ${achMonthlyCreditLimit} per month. Takes 4 to 5 business days.`,
      src: '/s2/material-icons/accountbalancerounded.svg'
    },
    {
      title: 'Check payments',
      description: `Limit ${checkPaymentDailyLimit} per day and ${checkPaymentMonthlyLimit} per month.`,
      src: '/s2/material-icons/bordercolorrounded.svg'
    },
    {
      title: 'Debit card expenses',
      description: `Limit ${dailyCardPurchaseLimit} per day.`,
      src: '/s2/material-icons/creditscorerounded.svg'
    },
    {
      title: 'ATM withdrawals',
      description: `Limit ${dailyCardWithdrawalLimit} per day.`,
      src: '/s2/material-icons/atmrounded.svg'
    }
  ];

  return (
    <DrawerOrDialog handleClose={handleClose}>
      <Stack
        gap={{ xs: '24px', md: '32px' }}
        my={{ xs: '16px', md: '20px' }}
        px={{ xs: 0, md: '16px' }}
      >
        <TitleAndDescription />
        <ListLimits
          limits={moneyInLimits}
          loading={loading}
          title="Money in"
        />
        <ListLimits
          limits={moneyOutLimits}
          loading={loading}
          title="Money out"
        />
      </Stack>
    </DrawerOrDialog>
  );
}

TransactionLimitsModal.propTypes = {
  handleClose: PropTypes.func
};
